import { Box, Stack } from '@mui/material';
import LangEnum from '../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';
import {
  LIVE_SHOP_CHAT_MIN_HEIGHT,
  LIVE_SHOP_CHAT_SECTION_CHROME_HEIGHT,
  buildYoutubeEmbedUrl,
  buildYoutubeLiveChatUrl,
} from '../../catalogLiveShop.utils';
import LiveShopMessages from './components/LiveShopMessages';

interface LiveShopPanelProps {
  isOpen: boolean;
  videoId: string;
  embedDomain: string;
}

const LiveShopPanel = ({ isOpen, videoId, embedDomain }: LiveShopPanelProps) => {
  const { translate } = useTranslation();
  const embedUrl = buildYoutubeEmbedUrl(videoId);
  const liveChatUrl = buildYoutubeLiveChatUrl({ videoId, embedDomain });

  return (
    <Stack
      test-id={CatalogProductsTestIds.LIVE_SHOP_PANEL}
      sx={{ height: '100%', minHeight: 0, gap: 1 }}
    >
      <Box
        sx={(theme) => ({
          flexShrink: 0,
          width: '100%',
          aspectRatio: '16 / 9',
          maxHeight: `calc(100% - ${LIVE_SHOP_CHAT_MIN_HEIGHT + LIVE_SHOP_CHAT_SECTION_CHROME_HEIGHT}px)`,
          borderRadius: `${theme.shape.borderRadius2xl}px`,
          overflow: 'hidden',
        })}
      >
        {isOpen && (
          <iframe
            src={embedUrl}
            title={translate(LangEnum.CATALOG_LIVE_SHOP_VIDEO_TITLE)}
            referrerPolicy="strict-origin-when-cross-origin"
            allow="autoplay; encrypted-media; fullscreen"
            allowFullScreen
            style={{ height: '100%', width: '100%', border: 0, display: 'block' }}
          />
        )}
      </Box>
      <LiveShopMessages isPanelOpen={isOpen} liveChatUrl={liveChatUrl} />
    </Stack>
  );
};

export default LiveShopPanel;
